(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookNodeDetailController', HandbookNodeDetailController);

    HandbookNodeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HandbookNode', 'HandbookVersion', 'File'];

    function HandbookNodeDetailController($scope, $rootScope, $stateParams, previousState, entity, HandbookNode, HandbookVersion, File) {
        var vm = this;

        vm.handbookNode = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:handbookNodeUpdate', function(event, result) {
            vm.handbookNode = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
